import {
  OBTENER_RECETA_DIGITAL_SUCCESS,
  OBTENER_RECETA_DIGITAL_ERROR,
  FIRMA_RECETA_DIGITAL_SUCCESS,
  FIRMA_RECETA_DIGITAL_ERROR,
} from '../constants/index';

export default function recetaDigital(state = {}, action) {
  const newState = { ...state };
  switch (action.type) {
    case OBTENER_RECETA_DIGITAL_ERROR:
      newState.recetas = [];
      return newState;
    case OBTENER_RECETA_DIGITAL_SUCCESS:
      newState.recetas = action.data;
      return newState;
    case FIRMA_RECETA_DIGITAL_SUCCESS:
      newState.firmaReceta = action.data;
      return newState;
    case FIRMA_RECETA_DIGITAL_ERROR:
      newState.firmaReceta = [];
      return newState;
    default:
      return newState;
  }
}
